import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../../../stem-core/src/base/Utils";
import {isSmallScreen} from "../../../../UtilsLib";


class InlineUserDashboardSectionStyle extends StyleSheet {
    @styleRule
    inlineSection = {
        padding: "12px 0",
        ":not(:last-child)": {
            borderBottom: "0.5px solid #E5E5E5",
        }
    };

    @styleRule
    header = {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 8,
    };

    @styleRule
    title = {
        fontSize: isSmallScreen() ? this.themeProps.MERCHANT_FONT_SIZE_LARGE : 18,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    action = this.themeProps.PAYWALL_LINK;
}

@registerStyle(InlineUserDashboardSectionStyle)
export class InlineUserDashboardSection extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            actionFunction: NOOP_FUNCTION,
            actionMessage: "",
            secondaryActionFunction: NOOP_FUNCTION,
            secondaryActionMessage: "",
            titleMessage: "",
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.inlineSection);
    }

    getChildrenToRender() {
        const {styleSheet} = this;
        const {titleMessage, actionMessage, actionFunction, secondaryActionMessage, secondaryActionFunction} = this.options;

        return [
            <div className={styleSheet.header}>
                {titleMessage ? <div className={styleSheet.title}>{titleMessage}</div> : null}
                <div style={{flex: 1}} />
                {secondaryActionMessage ? <div className={styleSheet.action} onClick={secondaryActionFunction} style={{marginRight: 12}}>{secondaryActionMessage}</div> : null}
                {actionMessage ? <div className={styleSheet.action} onClick={actionFunction}>{actionMessage}</div> : null}
            </div>,
            this.render(),
        ];
    }
}
